// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8547223","389":"3467da09","732":"9ec9bac4","857":"39be9c78","977":"334a3cf8"}[chunkId] + ".chunk.js";
};